import { render, staticRenderFns } from "./WalletDetails.vue?vue&type=template&id=76b15500&"
import script from "./WalletDetails.vue?vue&type=script&lang=js&"
export * from "./WalletDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports